import React from 'react';

/**
 * SaveSection component for save button and messaging
 */
const SaveSection = ({
  adminMode,
  saving,
  onSave,
  picksCount,
  scoresCount,
  editableScores,
}) => {
  // Calculate complete scores count
  const completeScoresCount = editableScores
    ? Object.keys(editableScores).filter(
        (id) =>
          editableScores[id].homeScore !== null && editableScores[id].awayScore !== null
      ).length
    : 0;

  return (
    <div className="save-section">
      <button
        onClick={onSave}
        disabled={saving || (adminMode ? scoresCount === 0 : picksCount === 0)}
        className="btn-save-all"
      >
        {saving
          ? 'Saving...'
          : adminMode
          ? `Save All Scores (${completeScoresCount})`
          : `Save All Picks (${picksCount})`}
      </button>
      <p className="save-notice">
        {adminMode
          ? 'Enter scores for matches and click save to update all scores at once'
          : 'You can change your picks anytime before each match locks'}
      </p>
    </div>
  );
};

export default SaveSection;
